import { Capacitor } from '@capacitor/core'
import { httpsCallable } from 'firebase/functions'
import { createStripePortalSession } from './api'
import { functions } from './firebase'

export type DeletionProtocolType = 'account' | 'data'

export interface DeletionProtocolResult {
  ok: boolean
  type: DeletionProtocolType
  graceDays: number
  executeAfterMs: number
}

const callRequestDeletionProtocol = httpsCallable<
  { type: DeletionProtocolType },
  DeletionProtocolResult
>(functions, 'requestDeletionProtocol', { limitedUseAppCheckTokens: true })

export async function startDeletionProtocol(
  type: DeletionProtocolType,
): Promise<DeletionProtocolResult> {
  const result = await callRequestDeletionProtocol({ type })
  return result.data
}

const appleSubscriptionsUrl = 'https://apps.apple.com/account/subscriptions'
const googleSubscriptionsUrl =
  'https://play.google.com/store/account/subscriptions?package=com.sponelabs.voxnela'

function storeManagementUrl(): string {
  if (Capacitor.getPlatform() === 'ios') return appleSubscriptionsUrl
  if (Capacitor.getPlatform() === 'android') return googleSubscriptionsUrl
  return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent)
    ? appleSubscriptionsUrl
    : googleSubscriptionsUrl
}

export async function openSubscriptionManagement(userId: string): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    try {
      const session = await createStripePortalSession()
      window.location.assign(session.url)
      return
    } catch (error) {
      console.warn(
        '[VOXNELA_SUBSCRIPTION] Stripe yönetim bağlantısı alınamadı.',
        error,
      )
      window.location.assign('/#/membership')
      return
    }
  }

  let url = storeManagementUrl()

  const revenueCatKey =
    Capacitor.getPlatform() === 'ios'
      ? import.meta.env.VITE_REVENUECAT_IOS_PUBLIC_KEY
      : import.meta.env.VITE_REVENUECAT_ANDROID_PUBLIC_KEY

  if (revenueCatKey) {
    try {
      const { Purchases } = await import('@revenuecat/purchases-capacitor')
      await Purchases.logIn({ appUserID: userId })
      const { customerInfo } = await Purchases.getCustomerInfo()
      url = customerInfo.managementURL ?? url
    } catch (error) {
      console.warn('[VOXNELA_SUBSCRIPTION] Mağaza yönetim bağlantısı alınamadı.', error)
    }
  }

  const { Browser } = await import('@capacitor/browser')
  await Browser.open({ url })
}
